import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { animateScroll } from 'react-scroll'
import block from 'bem-cn'

import { ReactComponent as Logo } from 'shared/img/logo.svg'

import { selectLocaleDict } from 'features/locale/selectors'

import { AgentLinkButton } from 'components/AgentLinkButton/AgentLinkButton'
import UserBlock from 'components/Header/desktop/UserBlock/UserBlock'
import SetLanguage from 'components/SetLanguage/SetLanguage'

import './TopHeader.scss'

const b = block('top-header-mobile')

const TopHeader: React.FC = () => {
  const locale = useSelector(selectLocaleDict, shallowEqual).common

  return (
    <div className={b()}>
      <div className={b('left')}>
        <Link to="/" className={b('logo-link')} aria-label={locale.home} onClick={() => animateScroll.scrollToTop()}>
          <Logo className={b('logo')} />
        </Link>
        {/* <SetLanguage /> */}
      </div>
      <div className={b('right')}>
        <AgentLinkButton isStatic />
        <UserBlock />
      </div>
    </div>
  )
}

export default TopHeader
